import React from "react";
import VoidpulseIcon from "../landing/VoidpulseIcon";

// Full-page message for 404s and route crashes; lives outside Template so it only uses static styles.
export const StatusPage: React.FC<{
  code: string;
  title: string;
  message: string;
  action: React.ReactNode;
}> = ({ code, title, message, action }) => (
  <main className="bg-primary-900 text-primary-100 flex min-h-screen flex-col items-center justify-center px-6 text-center">
    <VoidpulseIcon style={{ height: 40, width: 40 }} aria-hidden />
    <div className="text-accent-100 mt-6 text-xs font-semibold uppercase tracking-wider">{code}</div>
    <h1 className="mt-2 text-2xl font-semibold tracking-tight">{title}</h1>
    <p className="text-primary-400 mt-2 max-w-sm text-sm leading-6">{message}</p>
    <div className="mt-6">{action}</div>
  </main>
);

export const statusActionCn =
  "bg-accent-100 inline-flex h-9 items-center rounded-lg border border-white/10 px-4 text-sm font-medium text-white shadow-sm shadow-black/30 transition-[filter] hover:brightness-110";
